(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsd-plano-digital"] && !Shopify.designMode) return;
  try {
    
function rsdRecommend(answers) {
  if (answers.length !== 6) return null;
  const problem = answers[3];
  if (problem === 'automation' || problem === 'commerce') return problem;
  if (problem === 'capture') return answers[5] === 'demand' ? 'demand' : 'capture';
  return ['capture', 'commerce', 'automation', 'demand'].includes(answers[5]) ? answers[5] : 'capture';
}
function rsdInitialize() {
  document.querySelectorAll('[data-rsd-quiz]').forEach(quiz => {
    if (quiz.dataset.ready) return;
    quiz.dataset.ready = 'true';
    const root = quiz.closest('[data-rsd-page]');
    const steps = [...quiz.querySelectorAll('[data-step]')];
    const results = [...quiz.querySelectorAll('[data-result]')];
    const back = quiz.querySelector('[data-back]');
    const cta = quiz.querySelector('[data-result-cta]');
    const answers = [], labels = [];
    let current = 0, started = false;
    function render(focus) {
      const done = current === steps.length;
      const winner = done ? rsdRecommend(answers) : null;
      [...steps, ...results].forEach(el => {
        const active = steps[current] === el || (done && el.dataset.result === winner);
        el.hidden = !active;
        el.classList.toggle('is-active', active);
      });
      quiz.querySelector('[data-progress-label]').textContent = done ? quiz.dataset.completeLabel : `${current + 1} ${quiz.dataset.stepLabel} ${steps.length}`;
      quiz.querySelector('[data-progress-bar]').style.width = `${Math.min(current + 1, steps.length) / steps.length * 100}%`;
      back.hidden = current === 0;
      if (cta) cta.hidden = !done;
      const panel = done ? results.find(el => el.dataset.result === winner) : steps[current];
      const title = panel && panel.querySelector('h3,h2');
      const resultInput = root.querySelector('[data-result-input]');
      const answersInput = root.querySelector('[data-answers-input]');
      if (resultInput) resultInput.value = done && title ? title.textContent.trim() : 'Análise pessoal direta';
      if (answersInput) answersInput.value = done ? labels.join('\n') : '';
      if (focus && title) { title.tabIndex = -1; title.focus({preventScroll:true}); }
    }
    quiz.querySelectorAll('[data-answer]').forEach(button => button.addEventListener('click', () => {
      if (!started) { started = true; window.rsdTrack?.('quiz_start', {}); }
      answers[current] = button.dataset.answer;
      labels[current] = `${steps[current].querySelector('h3,h2')?.textContent.trim() || current + 1}: ${button.textContent.trim()}`;
      current += 1;
      render(true);
      if (current === steps.length) window.rsdTrack?.('quiz_complete', {result:rsdRecommend(answers)});
    }));
    back.addEventListener('click', () => { current = Math.max(0, current - 1); answers.splice(current); labels.splice(current); render(true); });
    render(false);
  });
  document.querySelectorAll('[data-rsd-demo]').forEach(demo => {
    if (demo.dataset.ready) return;
    demo.dataset.ready = 'true';
    demo.querySelectorAll('[data-demo-choice]').forEach(button => button.addEventListener('click', () => {
      demo.querySelector('[data-demo-placeholder]').hidden = true;
      demo.querySelectorAll('[data-demo-choice]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
      demo.querySelectorAll('[data-demo-result]').forEach(el => { el.hidden = el.dataset.demoResult !== button.dataset.demoChoice; });
    }));
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rsdInitialize); else rsdInitialize();
document.addEventListener('shopify:section:load', rsdInitialize);


  } catch(e) { console.error(e); }
})();
})();
